<template>
  <div class="bg-main registrateProgress">
    <div class="listTitle"></div>
    <card-wrap title="用户信息" class="cardWraps">
      <div class="baseInfo">
        <div class="baseInfoLeft">
          <img :src="dataForm.photoShow" width="100%"> 
        </div>
        <div class="baseInfoRight">
          <div style="display: flex;"><span class="desc">学籍状态</span><span style="color:rgb(35,173,241)">{{isShowPage ? '在籍': '报名中'}}</span></div>
          <div style="display: flex;"><span class="desc">学号</span><span>{{ dataForm.studentNo }}</span></div>
          <div style="display: flex;"><span class="desc">专业</span><span>{{dataForm.specialtyName}}</span></div>
          <div style="display: flex;"><span class="desc">学制</span><span>{{dataForm.yearsName}}</span></div>
          <div style="display: flex;" v-if="isShowPage"><span class="desc">入学时间</span><span>{{dataForm.recruitBatchId}}</span></div>
        </div>
      </div>
    </card-wrap>
    <card-wrap title="基础信息" class="cardWraps">
      <van-cell title="性别" :value="['男','女'][dataForm.gender-0]" />
      <van-cell title="出生日期" :value="dataForm.birthDate" />
      <van-cell title="民族" :value="dataForm.nationName" />
      <van-cell title="政治面貌" :value="dataForm.politicalStatusName" />
      <van-cell title="户口性质" :value="dataForm.ancestralNativeTypeName" />
      <van-cell title="通信地址" :value="fieldValue" />
      <van-cell title="详细地址" :value="dataForm.communicationDetailedAddress" />
    </card-wrap>
    <card-wrap title="工作及学习经历">
      <van-cell title="前置学历" :value="dataForm.oldDegreeLevelName" />
      <van-cell title="前置学历毕业院校" :value="dataForm.oldGraduated" />
    </card-wrap>
  </div>
</template>

<script>
import  {getStudentInfo} from '@/api/login'
import cardWrap from "@/pages/Home/component/cardWrap.vue";
import {admindivisionFirstList,admindivisionNextList} from '@/api/home' // 省份及下级
import {getFileUrl} from "@/api/common/index"// 上传
export default {
  name: "",
  data() {
    return {
      isShowPage: false,
      dataForm: {},
      fieldValue: ''
    }
  },
  components: {cardWrap},
  created(){
    this.getStudentInfoFn()
  },
  methods: {
    getStudentInfoFn() {
      getStudentInfo().then(res=>{
        if (res) {
          // this.isShowPage = res.approvalStatus >= 8 // 10 总部审核通过 改 大于8
          this.isShowPage = (res.approvalStatus==10)? true:false
          this.showDataFn(res)
          this.dataForm = res
        }
      })
    },
    // 数据回显
    async showDataFn(data) {
      
      // 照片
      getFileUrl({objectKey: data.photo}).then(datas=>{
        data.photoShow = datas
      })
      // 省市区
      admindivisionFirstList().then(res=>{
        data.communicationProvince && this.provinceCityAreaShow(data,res)
      })
    },
    // 省市区回显
    async provinceCityAreaShow(data,provinceList) {
      // 省市区
      const communicationProvinceItem = provinceList.filter(item=>item.areaCode == data.communicationProvince)
      this.fieldValue = communicationProvinceItem[0].areaName
      // 市
      communicationProvinceItem[0].children = await admindivisionNextList(communicationProvinceItem[0].areaCode)// 市列表
      const CityItem = communicationProvinceItem[0].children.filter(item=>item.areaCode == data.communicationPrefecturalCity) 
      this.fieldValue = this.fieldValue + '/' + CityItem[0].areaName
      // 区域
      CityItem[0].children = await admindivisionNextList(CityItem[0].areaCode) // 区
      const areaItem = CityItem[0].children.filter(item=>item.areaCode == data.communicationGroundArea) 
      this.fieldValue = this.fieldValue + '/' + areaItem[0].areaName
      // 街道
      if (data.communicationStreet) {
        areaItem[0].children = await admindivisionNextList(areaItem[0].areaCode) // 区
        const streetItem = areaItem[0].children.filter(item=>item.areaCode == data.communicationStreet) 
        this.fieldValue = this.fieldValue + '/' + streetItem[0].areaName
      }
    },
   
  },
};
</script> 
<style scoped>
.baseInfo {
  display: flex;
}
.baseInfoLeft,.baseInfoRight {
  flex-basis: 50%;
}
.baseInfoRight {
  color: #666;
  font-size: 15px;
  margin-left: 18px;
  line-height: 35px;
}
.baseInfoRight .desc {
  margin-right: 25px;
}
.registrateProgress {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  min-height: 100vh;
}
.jd {
  margin-top: 20px;
  display: flex;
}
.jd p {
  width: 190px;
}
.jd span {
  color: #666;
  font-size: 13px;
}
.cardWraps {
  margin-bottom: 10px;
}
/deep/.bottom-button {
  width: 80vw;
  height: 40px;
}
</style>


